<template>
  <div class="loading-dots">
    <span class="dot"></span>
    <span class="dot"></span>
    <span class="dot"></span>
  </div>
</template>

<script>
export default {
  name: 'LoadingDots'
}
</script>

<style lang="scss" scoped>
.loading-dots {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  background: #f0f0f0;
  border-radius: 8px;
  min-width: 60px;
  height: 36px;
  
  .dot {
    width: 8px;
    height: 8px;
    background: #999;
    border-radius: 50%;
    animation: pulse 1.4s infinite ease-in-out both;
    
    &:nth-child(1) {
      animation-delay: -0.32s;
    }
    
    &:nth-child(2) {
      animation-delay: -0.16s;
    }
  }
}

@keyframes pulse {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

// 暗色主题支持
@media (prefers-color-scheme: dark) {
  .loading-dots {
    background: #2a2a2a;
    
    .dot {
      background: #ddd;
    }
  }
}

// 对话框内的样式调整
.chat-msg-text .loading-dots {
  background: transparent;
  padding: 0;
  min-width: auto;
  height: auto;
}
</style>